// src/pages/ConfirmBooking/index.jsx
import React, { useEffect, useState } from "react";
import { PALETTE, useConfirmBookingCore } from "./core";
import ConfirmBookingMobile from "./ConfirmBookingMobile";
import ConfirmBookingDesktop from "./ConfirmBookingDesktop";
import LoginModal from "../../components/auth/LoginModal";

const ConfirmBooking = () => {
  // 🔁 All original logic (state, effects, seat lock, submit, etc.)
  const core = useConfirmBookingCore();

  const { missingData, bus, date, navigate } = core;

  // ✅ detect screen (ONLY change for proper rendering)
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 640);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // ⛔ missingData fallback — EXACT same UI
  if (missingData) {
    return (
      <div className="text-center mt-10">
        <p className="font-semibold" style={{ color: PALETTE.primary }}>
          Booking details are incomplete. Returning to search results.
        </p>
        <button
          onClick={() => {
            const params = new URLSearchParams({
              from: bus?.from || "",
              to: bus?.to || "",
              date: date || "",
            }).toString();

            // ✅ prevent ConfirmBooking from staying in browser history
            navigate(`/search-results?${params}`, { replace: true });
          }}
          className="mt-4 px-4 py-2 rounded-md text-white"
          style={{ background: PALETTE.primary }}
        >
          Go to Search Results
        </button>
      </div>
    );
  }

  // ✅ ONLY render one layout (no duplicate mount)
  return (
    <>
      {isMobile ? (
        <ConfirmBookingMobile {...core} />
      ) : (
        <ConfirmBookingDesktop {...core} />
      )}

      <LoginModal
        open={core.showLoginModal}
        onClose={core.closeLoginModal}
        onSuccess={core.handleLoginSuccess}
        redirectOverride="/confirm-booking"
      />
    </>
  );
};

export default ConfirmBooking;
